<div mat-dialog-content>
  <div class="checkbox-wrapper">
    <mat-checkbox [formControl]="acknowledged" color="primary"> Is Clustered?</mat-checkbox>

    <button style="float: right !important;" class="btn btn-primary animated-next pr-3" (click)="confirm()"
      *ngIf="!acknowledged.value">
      Proceed <mat-icon>chevron_right </mat-icon>
    </button>
  </div>

  <div class="section-wrapper mt-3 mb-4" *ngIf="acknowledged.value">
    <ng-container formArrayName="otherULBs">
      <div class="row" *ngFor="let item of otherUlbArray.controls as controls; let itemIndex=index">
        <ng-container [formGroupName]="itemIndex">
          <div class="col-lg-3">
            <app-search-ulb [name]="item.get('ulb')" [code]="item.get('ulbId')" [otherUlb]="otherUlbArray">
            </app-search-ulb>
          </div>
          <app-input-field class="col-lg-4" label="Distance (in kms) from Proposed Site"
            [control]="item.get('distance')" restrictedTo="numberOnly" maxlength="5" [decimalInput]="true" [decimalPlaces]="2"
            errMsg="Total (%)cannot be greater than 100">
          </app-input-field>

          <span *ngIf="itemIndex==0" class="col-lg-4 disabledIn">
            <app-input-field class="" maxlength="5" label="(%)Capacity to be allocated"
              [control]="item.get('percentage')" restrictedTo="numberOnly" [decimalInput]="true" [decimalPlaces]="2"
              errMsg="Total (%)cannot be greater than 100">
            </app-input-field>
          </span>
          <span *ngIf="itemIndex!=0" class="col-lg-4">
            <app-input-field *ngIf="itemIndex!=0" maxlength="5" label="(%)Capacity to be allocated"
              [control]="item.get('percentage')" restrictedTo="numberOnly" [decimalInput]="true" [decimalPlaces]="2"
              errMsg="Total (%)cannot be greater than 100">
            </app-input-field>
          </span>
        </ng-container>
        <div class="col-lg-1">
          <ng-container *ngIf="otherUlbArray.length>1 && itemIndex != 0">
            <mat-icon style="color:red" (click)="removeUlb(itemIndex,controls[itemIndex])">delete</mat-icon>
          </ng-container>
        </div>
      </div>

      <button class="btn btn-primary mt-3" type="button" (click)="addUlb()">Add More</button>
      <button style="left: 58%;position: relative;" class="btn btn-primary animated-next pr-3" (click)="confirm()">
        Proceed <mat-icon>chevron_right </mat-icon>
      </button>
    </ng-container>
  </div>

</div>